import { fetchInboxList } from "../../service/emailDetails";
import moment from "moment";
// import emailReport from "../emailReport/emailReport";

export default {
  components: {
    // emailReport,
  },
  props: {
    domainName: { type: String, required: true },
    selectedPeriod: { type: String, required: true },
  },
  data() {
    return {
      inboxList: [], // holds full dataset
      paginatedList: [], // data for current page
      loading: false,
      error: "",
      pageOptions: {
        pageSize: 10,
        pageNumber: 1,
        total: 0,
      },
      emailData: {},
      gmailSpamRatio: "0%",
      gmailInboxRatio: "0%",
      fromDate: "", // Ensure this is set when data is fetched
      toDate: ""
    };
  },
  mounted() {
    if (this.domainName) {
      this.addLoader();
    }
  },
  watch: {
    domainName(newDomain) {
      if (newDomain) {
          this.addLoader();
      }
    },
    selectedPeriod(newPeriod) {
      if (newPeriod) {
        this.pageOptions.pageNumber = 1;
        this.addLoader();
      }
    },
  },
  methods: {
    getDisplayTime(date) {
      return date ? moment(date, "ddd MMM DD YYYY").format("DD-MMM-YYYY") : "N/A";
    },
    addLoader() {
      this.loading = true;
      setTimeout(async () => {
        await this.fetchInboxList();
        this.loading = false;
      }, 500);
    },
    async fetchInboxList() {
      try {
        const period = this.selectedPeriod || "last-90";
        const params = {
          period,
          domain: this.domainName,
          offset: 0,
          limit: 1000,
        };
    
        console.log("Fetching inbox with params:", params);
        const data = await fetchInboxList(params);
    
        this.inboxList = data;
        this.pageOptions.total = data.length;
    
        // Calculate fromDate & toDate from the dataset
        if (data.length) {
          const dates = data.map(item => moment(item.date));
          const minDate = moment.min(dates);
          const maxDate = moment.max(dates);
          this.fromDate = minDate.toDate();
          this.toDate = maxDate.toDate();
          //  Emit to parent
          this.$emit("update-dates", {
            fromDate: this.fromDate,
            toDate: this.toDate
          });
        }
        // this.$emit("update-domain-name", this.domainName);

        this.paginateData();
        this.calculateRatios();
        this.calculateLineRatios();
      } catch (error) {
        console.error("Error fetching inbox list:", error);
        this.error = "Failed to fetch inbox list.";
      }
    },    
    paginateData() {
      const start = (this.pageOptions.pageNumber - 1) * this.pageOptions.pageSize;
      const end = start + this.pageOptions.pageSize;
      this.paginatedList = this.inboxList.slice(start, end); // only slice the data for current page
    },
    handlePageChange(newPage) {
      this.pageOptions.pageNumber = newPage;
      this.addLoader();
    },
    fetchSummaryData() {
      this.calculateRatios(); // this will emit the data correctly
    },    
    refreshReportData() {
      if (this.$refs.inboxTableRef && this.$refs.inboxTableRef.fetchSummaryData) {
        this.$refs.inboxTableRef.fetchSummaryData(); // <-- Make sure this triggers the API call and emits
      }
    },    
    calculatePercentage(part, total) {
      if (!total || total === 0) return "0%";
      const percentage = (part / total) * 100;
      return `${percentage.toFixed(2)}%`;
    },
    calculateRatios() {
      const totals = this.inboxList.reduce(
        (acc, email) => {
          acc.total_emails += email.total_emails || 0;
          acc.total_inbox += email.total_inbox || 0;
          acc.total_spam += email.total_spam || 0;
          acc.total_promotions += email.gmail_promotions || 0;
          acc.total_updates += email.gmail_update || 0;
          acc.total_primary += email.gmail_primary || 0;
          return acc;
        },
        {
          total_emails: 0,
          total_inbox: 0,
          total_spam: 0,
          total_promotions: 0,
          total_updates: 0,
          total_primary: 0
        }
      );

      this.emitData(totals);
    },
    emitData(totals) {
      this.$emit("update-report", totals); // send full data to parent for emailReport
      console.log("Emitting full data to parent:", totals);
    },
    calculateLineRatios() {
      const gmailData = this.inboxList
        .filter(email => email.date && email.gmail_inbox !== undefined)
        .map(email => ({
          date: moment(email.date).format("DD-MMM"),
          value: email.gmail_inbox || 0
        }));
      this.emitGmailData(gmailData);
    },
    emitGmailData(gmailData) {
      console.log("Emitting gmail_inbox data:", gmailData);
      this.$emit("update-gmail-data", gmailData);
    }
  },
};